export default __webpack_public_path__ + "static/media/logo_wobg.fb6f4da7.png";